module.exports = __webpack_public_path__ + "static/media/thekla-logo.44d169b3.png";